<template>

    <div class="uk-offcanvas-content">

        <div id="offcanvas-nav" uk-offcanvas="overlay: true">
            <div class="uk-offcanvas-bar mobile-navigation">

                <button class="uk-offcanvas-close" type="button" uk-close></button>

                <ul class="uk-nav uk-margin-top">
                    <li>
                        <a href="/login" v-show="!isLoggedIn">
                            <span class="icon"><font-awesome-icon :icon="['far', 'sign-in']" /></span> <span class="item">Login</span>
                        </a>
                    </li>
                    <li>
                        <a href="/app" v-show="isLoggedIn">
                            <span class="icon"><font-awesome-icon :icon="['far', 'home']" /></span> <span class="item">Dashboard</span>
                        </a>
                    </li>
                </ul>

            </div>
        </div>

    </div>

</template>

<script>
    export default {
        data () {
            return {

                isLoggedIn: this.$route.path === '/sign-up/timezone' || this.$route.path === '/sign-up/reminder',

            };
        },

        watch: {
            '$route' (to) {
                this.isLoggedIn = to.path === '/sign-up/timezone' || to.path === '/sign-up/reminder'
            }
        }
    }
</script>
